module.exports = __webpack_public_path__ + "img/application-1.b837108.png";